import styled from 'styled-components'

export const FilterBoxWrapper = styled.div`
  
`